/**
 * Created by Jerker Nord on 2018-04-24.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite, TweenLite} from "gsap";
import {IceIceYetiWildPresentationEvent} from "../../event/IceIceYetiWildPresentationEvent";
import {IceIceYetiGameShaker} from "../../gameshake/IceIceYetiGameShaker";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";
import {IWildInfo} from "../../server/IWildInfo";
import {StickyWild} from "../../symbol/StickyWild";

export class IceIceYetiWildAttentionView extends BaseView {

    private _layer:ScalableLayer;
    private _scaleWildLayer:ScalableLayer;
    private _stickyWilds:StickyWild[];
    private _scaleDownWilds:StickyWild[];

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.WILD_OVERLAY.name);
        this._scaleWildLayer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.STICKY_SYMBOL_OVERLAY.name);
        this._stickyWilds = [];
        this._scaleDownWilds = [];
    }

    protected initAnimations():void {
        this._layer.addChild(this);
    }

    public addRestoreWild(wildPosition:[number, number], originalSymbol:StateReelSymbol):void {
        const stickyWild:StickyWild = new StickyWild(originalSymbol, new PIXI.Point(wildPosition[0], wildPosition[1]), 1);
        const wildLayerPosition:number[] = Helper.getSymbolPositions(wildPosition[0], wildPosition[1]);
        stickyWild.position.x = wildLayerPosition[0];
        stickyWild.position.y = wildLayerPosition[1];
        stickyWild.getAnimation([0, 0]);
        this._stickyWilds.push(stickyWild);
        this._scaleWildLayer.addChild(stickyWild);
    }

    public addNewWild(wildPosition:PIXI.Point, originalSymbol:StateReelSymbol, index:number):StickyWild {
        const stickyWild:StickyWild = new StickyWild(originalSymbol, wildPosition, index);
        const wildLayerPosition:number[] = Helper.getSymbolPositions(wildPosition.x, wildPosition.y);

        stickyWild.position.x = wildLayerPosition[0];
        stickyWild.position.y = wildLayerPosition[1];

        this._stickyWilds.push(stickyWild);
        this.addChild(stickyWild);

        return stickyWild;
    }

    public addScaleDownStickyWild(reelId:number, symPosition:number):void {
        let tempWild:StickyWild;
        for(let i:number = 0; i < this._stickyWilds.length; i++) {
            tempWild = this._stickyWilds[i];
            if(tempWild.originalPosition.x == reelId && tempWild.originalPosition.y == symPosition) {
                this._scaleDownWilds.push(tempWild);
            }
        }
    }

    public playAllScaleDownWilds(reelId:number):void {
        let tempWild:StickyWild;
        for(let i:number = 0; i < this._scaleDownWilds.length; i++) {
            tempWild = this._scaleDownWilds[i];
            if(tempWild.originalPosition.x == reelId) {
                TweenLite.to(tempWild.scale, 0.3, {x : 1, y : 1});
            }
        }
        this._scaleDownWilds = [];
    }

    public scaleUpWilds():void {
        for(let i:number = 0; i < this._stickyWilds.length; i++) {
            TweenLite.to(this._stickyWilds[i].scale, 0.3, {x : 1.15, y : 1.15});
            TweenLite.to(Reels.getSymbol(this._stickyWilds[i].originalPosition.x, this._stickyWilds[i].originalPosition.y)!, 0.2, {alpha : 1});
        }
    }

    //Respin is over. Put Wilds on reels and remove them from sticky layer
    public removeAllWilds():void {
        let replaceTimeline:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < this._stickyWilds.length; i++) {
            replaceTimeline.add(Reels.getSymbol(this._stickyWilds[i].originalPosition.x, this._stickyWilds[i].originalPosition.y)!.replaceWith("W", this._stickyWilds[i].originalPosition.x));
            replaceTimeline.add(() => this._scaleWildLayer.removeChild(this._stickyWilds[i]));
        }
        replaceTimeline.add(() => this._stickyWilds = []);
        replaceTimeline.play();
    }

    public getWildAnimation(wildInfo:IWildInfo, index:number, isRespinWild:boolean):TimelineLite {
        const animation:TimelineLite = new TimelineLite();
        const stickyWild:StickyWild = this.addNewWild(wildInfo.wildPosition, Reels.getSymbol(wildInfo.wildPosition.x, wildInfo.wildPosition.y)!, index);
        let wildTurnSound:string;
        let wildPositionX:number = Helper.getSymbolPositions(stickyWild.originalPosition.x, stickyWild.originalPosition.y)[0];
        let wildPositionY:number = Helper.getSymbolPositions(stickyWild.originalPosition.x, stickyWild.originalPosition.y)[1];

        // Always move wild torwards center if it's on top or bottom position
        // If Mobile portrait mode, the wild animation needs to move in from the sides too.
        if(stickyWild.originalPosition.y == 0) {
            wildPositionY += IceIceYetiGameConfig.instance.SYMBOL_HEIGHT * 1.1;
        } else if(stickyWild.originalPosition.y == 6) {
            wildPositionY -= IceIceYetiGameConfig.instance.SYMBOL_HEIGHT * 1.1;
        }
        if(UserAgent.isMobile && StageManager.orientation == Orientation.PORTRAIT) {
            if(stickyWild.originalPosition.x == 0) {
                wildPositionX += IceIceYetiGameConfig.instance.SYMBOL_WIDTH * 1.1;
            } else if(stickyWild.originalPosition.x == 4) {
                wildPositionX -= IceIceYetiGameConfig.instance.SYMBOL_WIDTH * 1.1;
            }
        }

        animation.add(() => {
            this.addChild(stickyWild);
        });
        if(stickyWild.animationIndex == 0) {
            //Yeti Wild
            if(isRespinWild == true) {
                wildTurnSound = IceIceYetiSoundConfig.instance.WILD_TURNS_RESPIN;
            } else {
                wildTurnSound = IceIceYetiSoundConfig.instance.WILD_TURNS;
            }
            animation.add([
                () => {
                    SlotGame.sound.playEffect(wildTurnSound)
                },
                stickyWild.getAnimation([0, 11])
            ]);

            animation.add([
                stickyWild.getAnimation([12, 62]),
                new TweenLite(stickyWild.position, 0.4, {
                    x : wildPositionX,
                    y : wildPositionY
                })
            ]);

            animation.add([
                stickyWild.getAnimation([63, 66]),
                new TweenLite(stickyWild.position, 0.15, {
                    x : Helper.getSymbolPositions(stickyWild.originalPosition.x, stickyWild.originalPosition.y)[0],
                    y : Helper.getSymbolPositions(stickyWild.originalPosition.x, stickyWild.originalPosition.y)[1]
                })
            ]);
            animation.add(() => this._scaleWildLayer.addChild(stickyWild));
            animation.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiGameShaker.START_GAME_SHAKING)), "-=0.1");
            animation.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiWildPresentationEvent.CRACK_ICE, wildInfo.areaOpenPositions)));
            animation.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiGameShaker.STOP_GAME_SHAKING)), "+=1.2");
            animation.add(stickyWild.getAnimation([67]), "-=1.2");
        } else {
            // Fast Wild, no Yeti
            animation.add([
                () => {
                    SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.WILD_TURNS_NO_YETI)
                },
                stickyWild.getAnimation([0, 13])
            ]);
            animation.add([
                stickyWild.getAnimation([14, 26]),
                new TweenLite(stickyWild.position, 0.4, {
                    x : wildPositionX,
                    y : wildPositionY
                })
            ]);
            animation.add(
                stickyWild.getAnimation([27, 29]));
            animation.add([
                stickyWild.getAnimation([30, 34]),
                new TweenLite(stickyWild.position, 0.16, {
                    x : Helper.getSymbolPositions(stickyWild.originalPosition.x, stickyWild.originalPosition.y)[0],
                    y : Helper.getSymbolPositions(stickyWild.originalPosition.x, stickyWild.originalPosition.y)[1]
                })
            ]);
            animation.add(() => this._scaleWildLayer.addChild(stickyWild));
            animation.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiGameShaker.START_GAME_SHAKING)), "-=0.1");
            animation.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiWildPresentationEvent.CRACK_ICE, wildInfo.areaOpenPositions)));
            animation.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiGameShaker.STOP_GAME_SHAKING)), "+=0.8");
            animation.add(
                stickyWild.getAnimation([35])
                , "-=0.8");
        }

        return animation;
    }
}